import React from 'react';

export default function FusionLogo({ className, alt = 'Fusion', variant = 'dark', portrait = false, icon = false }) {
  // `icon` = mark-only Fusion F (no wordmark, transparent SVG), for
  // lockups that supply their own text beside the mark (e.g. the sidebar
  // header). `portrait` = full icon + FUSION wordmark vector lockup.
  const src = icon
    ? '/fusion-icon.svg'
    : portrait
      ? '/fusion-logo-dark-portrait.svg'
      : variant === 'light'
        ? '/fusion-logo.png'
        : '/fusion-logo-dark.png';

  return <img src={src} alt={alt} className={className} />;
}
